<div class="modal-header bg-black lter">

    <div class="row">
        <div class="col-xs-10 col-sm-10 col-md-11">
            <h5 class="modal-title text-white font-thin font-bold ">
                Email Communication
            </h5>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-1 ">
            <button class="pull-right text-white modal-btn-hdr" ng-click="done()">
                <i class="glyphicon glyphicon-remove-circle"></i>
            </button>
        </div>
    </div>

</div>
<div class="modal-body no-padder bg-white-only">

    <div class="hbox hbox-auto-xs bg-light">
        <div class="col bg-white-only">
            <div class="vbox">
                <div class="row-row">
                    <div class="cell scrollable">
                        <div class="cell-inner">
                            <iframe ng-show="email_campaign_url" iframe-auto-size width="100%" frameborder="0" data-ng-src="{{email_campaign_url}}"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
